
import React, {Component} from 'react';
import { ButtonToolbar, Pagination, Tabs, Tab, HelpBlock, DropdownButton, MenuItem, Button, Form, FormControl, FormGroup, InputGroup, ControlLabel, Row, Col, Popover, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import './Tutorial.css';
import thumbnail from './img/thumbnail/playvideo.png';

const mainUrl = 'https://drive.google.com/uc?export=download&id='
class TutorialPage extends Component {

  constructor(...args){
    super(...args)
    this.state = { 
      displayVideoList: "", 
      displayVideoPlay: "none",
      videoTitle: "",
      btnTitle: "Sort By: Release Type",
      eventKey: "",
      // srcVideo: [],
      // videoId: "",
      data: [
        {
          title: "01 การเพิ่มใบงาน",          
          thumbnail: "",
          category: "",
          categoryId: "1",
          id: "1b5O4PqML14SKJd6j_YYjbJx32pMLJUAT"
        },
        {
          title: "02 การออกใบตรวจสภาพรถ",
          thumbnail: "",
          category: "",
          categoryId: "2",
          id: "1ZVvGsShONmi_qHU6m_e_rjfBzI5fHg9a"
        },
        {
          title: "03 การคุมราคา",
          thumbnail: "",
          category: "",
          categoryId: "3",
          id: "1i2PQ_IlcOIKCvK9micuo2RK_T9zPozUO"
        },
        {
          title: "04 การเทียบราคาอะไหล่ร้าน",          
          thumbnail: "",
          category: "",
          categoryId: "4",
          id: "1kZ5LqKXv3EQwkpJDhG4mQxWqh3CtYhMH"
        },
        {
          title: "05 การอัพโหลดรูปและใบงาน",
          thumbnail: "",
          category: "",
          categoryId: "5",
          id: "1P3qqXH5ev9EGqZgKhBhk_Khz2f8o-o_k"
        },
        {
          title: "06 การควบคุมงาน",
          thumbnail: "",
          category: "",
          categoryId: "6",
          id: "1eiLC_HbQmEq5nOwFjVpPChLaqV1hVLfh"
        },
        {
          title: "07 การวางแผนงาน",          
          thumbnail: "",
          category: "",
          categoryId: "7",
          id: "1S4efQmTzn7ivoEyBRMk_qVykYTJAVH7_"
        },
        {
          title: "08 การเพิ่มอะไหล่ในสต๊อก",          
          thumbnail: "",
          category: "",
          categoryId: "8",
          id: "1pAjc6zSa4FIPUPaboblE08DVkYSmXJLU"
        },
        {
          title: "09 การเช็คสต๊อก",
          thumbnail: "",
          category: "",
          categoryId: "9",
          id: "1pTH5NczF1opieRfmA9-zu4kLaBcOiG4D"
        },
        {
          title: "10 การเพิ่มพนักงานฝ่ายบุคคล",          
          thumbnail: "",
          category: "",
          categoryId: "10",
          id: "1IPqSdjJT1FnRuZqMc2qtEZoJy4l8LbFT"
        },
        {
          title: "11 การออกสลิปเงินเดือน",
          thumbnail: "",
          category: "",
          categoryId: "11",
          id: "1KSwQXCFHO6Nq30oP6LYv_hjFPeVZgrYM"
        },
        {
          title: "12 การออกเอกสาร",
          thumbnail: "",
          category: "",
          categoryId: "12",
          id: "1RGgv4Q3IOOjOirkT_CzWUmqMlisy4Lqd"
        }
      ] 
    }
  }

  componentDidMount(){
    // let that = this
    // axios.get('https://api.bigfix.co/appsite/tutorial/video/fasttrack')
    // .then(function(response){
    //   console.log(response)
    //   that.setState({data:response.data})
    // })
    // .catch(function (error) {
    //   console.log(error);
      
    // })
    
  }

  onVideoClick(item, e) { 
    let videoId = mainUrl + item.id
    
    // videoId = "https://drive.google.com/uc?export=download&id="+id
    // let {srcVideo} = this.state
    // srcVideo[0] = videoId
    
    setTimeout(function() {  
      var video = document.getElementById('video');
      var source = document.getElementById('source');
      video.pause();
  
      source.setAttribute('src', videoId); 
  
      video.load();
      video.play();
    }, 500);

    this.setState({displayVideoList:"none", displayVideoPlay:"", videoTitle:item.title})
  }

  onMenuItemSelect(index){
    var btnTitle = ""
    if (index=="1") {
      btnTitle = "การทำใบงานต่างๆจากหน้างาน"
    } else if (index=="2") {
      btnTitle = "การทำใบเสนอราคาตั้งแต่เริ่ม"
    } else if (index=="3") {
      btnTitle = "คลังสินค้าการเช็คสต็อก"
    } else if (index=="4") {
      btnTitle = "คลังสินค้า เช็คสินค้าขาดสต็อก"
    } else if (index=="5") {
      btnTitle = "คลังสินค้า ดูรายงาน"
    } else if (index=="6") {
      btnTitle = "เมนูดูยอดรวม"
    } else if (index=="7") {
      btnTitle = "เมนูใบงาน การสร้างใบงาน"
    } else if (index=="8") {
      btnTitle = "เมนูใบงาน ดูสถานะใบงาน"
    } else if (index=="9") {
      btnTitle = "เมนูปฏิทิน"
    } else if (index=="10") {
      btnTitle = "เมนูลูกค้า ค้นหาลูกค้า"
    } else if (index=="11") {
      btnTitle = "เมนูลูกค้า ดูรายงาน"
    } else if (index=="12") {
      btnTitle = "เมนูลูกค้า วิธีเพิ่มลูกค้า"
    } else if (index=="13") {
      btnTitle = "เมนูเอกสาร การดูรายงานเอกสาร"
    } else if (index=="14") {
      btnTitle = "วิธีพิมพ์ใบงานความเสียหายและใบติดหน้ารถ"
    } else if (index=="15") {
      btnTitle = "วิธีเลือกโปรแกรมงาน"
    } else {
      btnTitle = "Sort By: Release Type"
    }
    
    this.setState({ eventKey:index, btnTitle:btnTitle })
  }

  onBackClick(e) {
    var video = document.getElementById('video');
    video.pause();

    this.setState({displayVideoList:"", displayVideoPlay:"none"})
  }

  render(){
    return (
      <div>
        {this.renderVideoList()}  
        {this.renderVideoPlay()}
      </div>
    )
  }

  renderVideoPlay(){

    return(
      <div className="container" style={{display:this.state.displayVideoPlay}}>
        <div className="row">
          <div className="col-md-12">
            <Box>
              <Box.Header>
                <Box.Title></Box.Title>
                <Box.Tools>
                  <Button className="btn btn-default" onClick={this.onBackClick.bind(this)}>ย้อนกลับ</Button>
                </Box.Tools>
              </Box.Header>
              <Box.Body>
                <div className="row box-video">
                  <div className="col-md-12">
                    <div className="video-play-title">
                      <p className="title-video-play">{this.state.videoTitle}</p>
                    </div>
                    <video id="video" controls="controls" width="100%" height="100%">
                      <source id="source" src="" type='video/mp4'/>
                    </video>
                    <div className="video-play-descript">
                      <p>คำอธิบาย</p>
                    </div>
                  </div>
                </div>
              </Box.Body>              
            </Box>
          </div>
        </div>
      </div>          
    )
  }

  renderVideoList(){
    return(
      <div className="container" style={{display:this.state.displayVideoList}}>
        <div className="row">
          <div className="col-md-12">
            <Box>
              <Box.Header>
                <Box.Title>วิธีการใช้งานโปรแกรม</Box.Title>
                <Box.Tools >
                  <ButtonToolbar style={{display:'none'}}>
                    <DropdownButton title={this.state.btnTitle} onSelect={this.onMenuItemSelect.bind(this)} id="dropdown-size-medium">
                      <MenuItem eventKey="">Sort By: Release Type</MenuItem>
                      <MenuItem eventKey="1">การทำใบงานต่างๆจากหน้างาน</MenuItem>
                      <MenuItem eventKey="2">การทำใบเสนอราคาตั้งแต่เริ่ม</MenuItem>
                      <MenuItem eventKey="3">คลังสินค้าการเช็คสต็อก</MenuItem>
                      <MenuItem eventKey="4">คลังสินค้า เช็คสินค้าขาดสต็อก</MenuItem>
                      <MenuItem eventKey="5">คลังสินค้า ดูรายงาน</MenuItem>
                      <MenuItem eventKey="6">เมนูดูยอดรวม</MenuItem>
                      <MenuItem eventKey="7">เมนูใบงาน การสร้างใบงาน</MenuItem>
                      <MenuItem eventKey="8">เมนูใบงาน ดูสถานะใบงาน</MenuItem>
                      <MenuItem eventKey="9">เมนูปฏิทิน</MenuItem>
                      <MenuItem eventKey="10">เมนูลูกค้า ค้นหาลูกค้า</MenuItem>
                      <MenuItem eventKey="11">เมนูลูกค้า ดูรายงาน</MenuItem>
                      <MenuItem eventKey="12">เมนูลูกค้า วิธีเพิ่มลูกค้า</MenuItem>
                      <MenuItem eventKey="13">เมนูเอกสาร การดูรายงานเอกสาร</MenuItem>
                      <MenuItem eventKey="14">วิธีพิมพ์ใบงานความเสียหายและใบติดหน้ารถ</MenuItem>
                      <MenuItem eventKey="15">วิธีเลือกโปรแกรมงาน</MenuItem>
                    </DropdownButton>
                  </ButtonToolbar>
                </Box.Tools>
              </Box.Header>
              <Box.Body>
                {this.renderRowVideoList()}
              </Box.Body>
            </Box>
          </div>
        </div>
      </div>
    )
  }

  renderRowVideoList() {
    let {eventKey} = this.state

    return(
      this.state.data.map((item, index) => {
        return(
          <div key={index} style={{display:(eventKey===item.categoryId||eventKey==="")?'block':'none'}}>
            <div className="row box-video">
              <div className="col-md-4" onClick={this.onVideoClick.bind(this,item)}>
                <img src={thumbnail} width="250" height="140" />
              </div>
              <div className="col-md-8">
                <p className="title-video">{item.title}</p>
                <p></p>
              </div>
            </div>
          </div>  
        )
      })
    )
  }

}


export default TutorialPage;





// WEBPACK FOOTER //
// ./src/view/tutorial/TutorialPage.js